<template>
  <div>
    <section style="padding-top: 150px;">
      <div>
        <div>
          <div class="container">
            <h4>Publishings Supported Languages</h4>
            <p>
              You can add/edit your publishings with content and metadata
              written in the supported languages listed below.
            </p>
            <p>
              We’re continually working on ways to support more languages. You
              can follow our <a href="/blog">blog</a>.
            </p>
            <h6>Electronic Communications</h6>
            <div>
              <b-table striped hover :items="items"></b-table>
            </div>
            <!--
              Afrikaans	French	Manx
              Alsatian	Frisian	Northern Frisian
              Arabic (eBook only)	Galician	Norwegian
              Basque	German	Nynorsk Norwegian
              Bokmål Norwegian	Gujarati (eBook only)	Polish (paperback and hardcover only)
              Breton	Hebrew (paperback only)	Portuguese
              Catalan	Hindi (eBook only)	Provençal
              Chinese (Traditional) (eBook only)	Icelandic	Romansh
              Cornish	Irish	Scots
              Corsican	Italian	Scottish Gaelic
              Danish	Japanese (eBook and paperback only)
              Spanish
              Dutch/Flemish	Latin (paperback and hardcover only)	Swedish
              Eastern Frisian	Luxembourgish	Tamil (eBook only)
              English	Marathi (eBook only)	Ukrainian (paperback and hardcover only)
              Finnish	Malayalam (eBook only)	Welsh
              -->
            <p>
              To learn more, read specific guidelines for publishing books in
              these languages:
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HelpLanguageSupport",
  data() {
    return {
      items: [
        { language: "Afrikaans", availability: "since September 14, 2022" },
        { language: "French", availability: "since September 14, 2022" },
        { language: "English (UK)", availability: "since September 14, 2022" },
        { language: "English (US)", availability: "since September 14, 2022" },
        { language: "Spanish", availability: "since September 14, 2022" },
        { language: "Hindi", availability: "since September 14, 2022" }
      ]
    };
  }
};
</script>
